import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import frTranslations from './locales/fr/translation.json'
import enTranslations from './locales/en/translation.json'
import frCguTranslations from './locales/fr/cgu.json'
import enCguTranslations from './locales/en/cgu.json'
import frPrivacyTranslations from './locales/fr/privacy.json'
import enPrivacyTranslations from './locales/en/privacy.json'

const resources = {
  fr: {
    translation: {
      ...frTranslations,
      cgu: frCguTranslations,
      privacy: frPrivacyTranslations
    },
  },
  en: {
    translation: {
      ...enTranslations,
      cgu: enCguTranslations,
      privacy: enPrivacyTranslations
    },
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
